import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'
import { ChatLayout } from '../components/chat/ChatLayout'
import { AuthGuard } from '../components/Auth/AuthGuard'
import { useConversationStore } from '../stores/conversationStore'

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): { slide: string | undefined; look?: string } => {
    return {
      slide: search.slide as string | undefined,
      ...(typeof search.look === 'string' ? { look: search.look } : {}),
    }
  },
  // learn.4klabs.ai is the public catalog front door — its root lands on /learn
  // (the home route is auth-gated and would otherwise bounce visitors to login).
  beforeLoad: () => {
    if (typeof window !== 'undefined' && window.location.hostname.startsWith('learn.')) {
      throw redirect({ to: '/learn' })
    }
  },
  component: HomeRoute,
})

function HomeRoute() {
  const { activeConversationId, setActiveConversation } = useConversationStore()

  // Clear active conversation when landing on home page
  // This ensures hero screen shows properly when navigating from workspaces
  useEffect(() => {
    if (activeConversationId) {
      console.log('🏠 Home: Clearing stale active conversation:', activeConversationId)
      setActiveConversation(null)
    }
  }, [activeConversationId, setActiveConversation])

  return (
    <AuthGuard>
      <ChatLayout />
    </AuthGuard>
  )
}